export const TIME_LOCAL_PAGE_TIMER = '00:30';    // Tiempo para mostrar modal (30 segundos)
export const TIME_EXPIRED_PAGE_TIMER = '15:00';  // Tiempo para cupos expirados
export const TIME_INITIAL_PAGE_TIMER = '03:00';  // Tiempo inicial del timer (4 minutos)
export const TIME_ZERO = '00:00';                // Tiempo para mostrar modal de sesión cerrada

// Re-exportar la paleta de colores
export { COURSE_COLORS, getRandomColor, generateHash } from './colors';